<template>
    <div class="py-2 md:py-4 relative">
        <div
            class="flex items-center gap-2 rounded-[var(--radius-md-base,4px)] justify-center mx-auto"
        >
            <icon icon="arrow-left-small" />
            <a href="#" class="text-slate-800">Back to my space</a>
        </div>
        <div class="h-16"></div>
        <div class="flex justify-center items-center">
            <icon icon="10xTravel" />
        </div>
        <div class="h-10"></div>

        <div
            class="flex flex-col md:flex-row md:justify-center items-center mb-5"
        >
            <div>
                <h1 class="text-5xl font-bold text-slate-800 text-center">
                    Upgrade your
                    <br />
                    10xTravel Experience
                </h1>
                <p class="text-slate-500 text-base text-center pt-3">
                    Get exclusive members-only deals, dedicated support from our
                    <br />
                    experts, discounts, random surprises, and more.
                </p>
                <div class="mt-4 text-center pt-6">
                    <button
                        class="bg-orange text-white text-xs font-bold py-2.5 px-4 rounded hover:bg-orange-600"
                        type="button"
                        @click="showPaymentForm = true"
                    >
                        Get Started
                    </button>
                </div>
            </div>
        </div>
        <div class="mt-36 pl-14">
            <h2 class="text-2xl font-semibold text-slate-800 text-left">
                Meet your
                <span class="text-orange">10xTravel+</span>
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div class="bg-white p-4 shadow rounded-lg">
                    <div class="flex items-center justify-center">
                        <icon icon="plane" />
                    </div>
                    <div class="gap-2 justify-left">
                        <p class="font-semibold text-slate-800">
                            Free & discounted award bookings
                        </p>
                        <p class="text-slate-500">
                            All 10xTravel+ members receive one free Award
                            Booking per year, as well as a 15% discount on all
                            other.
                        </p>
                    </div>
                </div>
                <div class="bg-white p-4 shadow rounded-lg">
                    <div class="flex items-center justify-center">
                        <icon icon="chat-messages" />
                    </div>
                    <div class="gap-2 justify-left">
                        <p class="font-semibold text-slate-800">
                            Enhanced support from 10xT staff
                        </p>
                        <p class="text-slate-500">
                            10xTravel+ members have direct access to 10xT staff
                            to get your questions answered one on one, and fast.
                        </p>
                    </div>
                </div>
                <div class="bg-white p-4 shadow rounded-lg">
                    <div class="flex items-center justify-center">
                        <icon icon="bell" />
                    </div>
                    <div class="gap-2 justify-left">
                        <p class="font-semibold text-slate-800">
                            Early access to deals
                        </p>
                        <p class="text-slate-500">
                            You’ll be the first to know about killer flight
                            deals and award space, giving you plenty of time to
                            book before they are gone.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-24 pl-14">
            <h2 class="text-2xl font-semibold text-slate-800 text-left">
                What people say
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div class="bg-white p-4 shadow rounded-lg">
                    <div class="flex items-center justify-left">
                        <icon icon="quote" />
                    </div>
                    <div class="gap-2 justify-left pt-2">
                        <p class="text-slate-800 text-base">
                            I recently had the pleasure of working with
                            10xTravel+, and although I didn't end up using his
                            services, I was thoroughly impressed by his
                            dedication and professionalism. I would highly
                            recommend 10xTravel+ to anyone looking for expert
                            guidance.
                        </p>
                        <p class="text-slate-500 text-base pt-2">— Ann</p>
                    </div>
                </div>
                <div class="bg-white p-4 shadow rounded-lg">
                    <div class="flex items-center justify-left">
                        <icon icon="quote" />
                    </div>
                    <div class="gap-2 justify-left pt-2">
                        <p class="text-slate-800 text-base">
                            I recently had the pleasure of working with
                            10xTravel+, and although I didn't end up using his
                            services, I was thoroughly impressed by his
                            dedication and professionalism. I would highly
                            recommend 10xTravel+ to anyone looking for expert
                            guidance.
                        </p>
                        <p class="text-slate-500 text-base pt-2">— Nick</p>
                    </div>
                </div>
                <div class="bg-white p-4 shadow rounded-lg">
                    <div class="flex items-center justify-left">
                        <icon icon="quote" />
                    </div>
                    <div class="gap-2 justify-left pt-2">
                        <p class="text-slate-800 text-base">
                            I recently had the pleasure of working with
                            10xTravel+, and although I didn't end up using his
                            services, I was thoroughly impressed by his
                            dedication and professionalism. I would highly
                            recommend 10xTravel+ to anyone looking for expert
                            guidance.
                        </p>
                        <p class="text-slate-500 text-base pt-2">— Bob</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="h-40"></div>
        <div class="justify-center items-center mb-5">
            <div>
                <h1 class="text-3xl font-bold text-slate-800 text-center">
                    One simple plan
                </h1>
                <p class="text-slate-500 text-base text-center">
                    Unlock exclusive deals for members, expert support,
                    <br />
                    discounts, unexpected surprises, and more.
                </p>
            </div>
        </div>

        <div
            class="flex flex-col md:flex-row items-start justify-between bg-white shadow-lg rounded-3xl p-8 w-[1008px] h-[450px] mx-auto mt-8"
        >
            <div class="w-full md:w-1/2 pr-6">
                <h1 class="text-red-500 text-3xl font-semibold">
                    10xTravel+
                    <br />
                    <span class="text-gray-900">membership</span>
                </h1>
                <div class="relative mt-8">
                    <icon icon="plane-looping"></icon>
                </div>

                <div class="flex gap-2">
                    <p class="text-gray-900 text-4xl font-bold">$199</p>
                    <div class="flex flex-col items-left">
                        <span class="text-gray-500 font-sm">per year</span>
                        <span class="text-gray-500 text-sm">paid annually</span>
                    </div>
                </div>
            </div>
            <div
                class="relative min-h-screen bg-gray-100 flex items-center justify-center"
            >
                <div
                    class="absolute w-7 h-7 bg-slate-100 rounded-full"
                    style="top: -45px; left: -10px"
                ></div>
            </div>
            <div
                class="relative min-h-screen bg-slate-100 flex items-center justify-center"
            >
                <div
                    class="absolute w-7 h-7 bg-slate-100 rounded-full shadow-inner"
                    style="top: 405px; left: -10px"
                ></div>
            </div>
            <svg height="400" width="10">
                <line
                    x1="5"
                    y1="0"
                    x2="5"
                    y2="400"
                    stroke="#D3D3D3"
                    stroke-width="5"
                    stroke-dasharray="25, 15"
                    stroke-linecap="round"
                />
            </svg>
            <div class="w-full md:w-3/2 pl-6 flex flex-col items-start">
                <h2 class="text-gray-900 text-xl font-bold mb-4">
                    What you’ll get
                </h2>
                <ul class="space-y-4">
                    <li class="flex items-center">
                        <icon icon="CheckIcon" class="w-6 h-6" />
                        <span class="ml-3 text-gray-800 text-md">
                            Free signup gift
                        </span>
                    </li>
                    <li class="flex items-center">
                        <icon icon="CheckIcon" class="w-6 h-6" />
                        <span class="ml-3 text-gray-800 text-md">
                            One free award booking per year (round trip for 2,
                            issued as a credit of $275 on your bookings)
                        </span>
                    </li>
                    <li class="flex items-center">
                        <icon icon="CheckIcon" class="w-6 h-6" />
                        <span class="ml-3 text-gray-800 text-md">
                            15% off of future award bookings, no limit
                        </span>
                    </li>
                    <li class="flex items-center">
                        <icon icon="CheckIcon" class="w-6 h-6" />
                        <span class="ml-3 text-gray-800 text-md">
                            Priority access to award bookings, faster
                            turnarounds
                        </span>
                    </li>
                    <li class="flex items-center">
                        <icon icon="CheckIcon" class="w-6 h-6" />
                        <span class="ml-3 text-gray-800 text-md">
                            Advanced access to 10xT Award Alerts
                        </span>
                    </li>
                    <li class="flex items-center">
                        <icon icon="CheckIcon" class="w-6 h-6" />
                        <span class="ml-3 text-gray-800 text-md">
                            Access to 1:1 consults with 10xT staff (max 2 per
                            year)
                        </span>
                    </li>
                    <li class="flex items-center">
                        <icon icon="CheckIcon" class="w-6 h-6" />
                        <span class="ml-3 text-gray-800 text-md">
                            Get your questions answered on our podcast
                        </span>
                    </li>
                </ul>
                <div class="pt-4">
                    <button
                        class="ml-3 bg-orange text-white px-4 py-2.5 rounded-lg hover:bg-orange-500 font-inter text-[14px] font-normal leading-[20px]"
                        type="button"
                        @click="showPaymentForm = true"
                    >
                        Get started
                    </button>
                </div>
            </div>
        </div>
        <div class="flex flex-col items-left justify-left mt-20 pl-14 gap-6">
            <div>
                <h1 class="text-3xl font-semibold text-slate-800 text-left">
                    Common questions about your
                    <span class="text-orange">10xTravel+</span>
                </h1>
            </div>
            <div class="flex w-[1008px] flex-col items-start">
                <div
                    class="flex py-4 items-start gap-6 self-stretch rounded-lg justify-between"
                >
                    <p
                        class="self-stretch text-[var(--text-icons-primary,#1E293B)] font-inter text-[20px] font-normal leading-[28px]"
                    >
                        What are the benefits of award booking for me?
                    </p>
                    <icon icon="plus+icon" class="w-6 h-6 ml-auto" />
                </div>

                <div
                    class="flex py-4 items-start gap-6 self-stretch rounded-lg justify-between"
                >
                    <p
                        class="self-stretch text-[var(--text-icons-primary,#1E293B)] font-inter text-[20px] font-normal leading-[28px]"
                    >
                        What do I get with advanced access to award alerts?
                    </p>
                    <icon icon="plus+icon" class="w-6 h-6 ml-auto" />
                </div>

                <div
                    class="flex py-4 items-start gap-6 self-stretch rounded-lg justify-between"
                >
                    <p
                        class="self-stretch text-[var(--text-icons-primary,#1E293B)] font-inter text-[20px] font-normal leading-[28px]"
                    >
                        What can I learn during the 1:1 consult?
                    </p>
                    <icon icon="plus+icon" class="w-6 h-6 ml-auto" />
                </div>

                <div
                    class="flex py-4 items-start gap-6 self-stretch rounded-lg justify-between"
                >
                    <p
                        class="self-stretch text-[var(--text-icons-primary,#1E293B)] font-inter text-[20px] font-normal leading-[28px]"
                    >
                        Do you respond to all voice messages on the podcast?
                    </p>
                    <icon icon="plus+icon" class="w-6 h-6 ml-auto" />
                </div>
                <div
                    class="flex py-4 items-start gap-6 self-stretch rounded-lg justify-between"
                >
                    <p
                        class="self-stretch text-[var(--text-icons-primary,#1E293B)] font-inter text-[20px] font-normal leading-[28px]"
                    >
                        I want something that's not included in the
                        subscription. How can I get it?
                    </p>
                    <icon icon="plus+icon" class="w-6 h-6 ml-auto" />
                </div>
            </div>
        </div>

        <transition name="fade">
            <div
                class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-60"
                v-show="showPaymentForm"
            ></div>
        </transition>
        <div
            class="w-full max-w-96 bg-white fixed border-l border-gray-200 top-0 right-0 bottom-0 transition-transform duration-500 z-[70]"
            :class="{
                'translate-x-0': showPaymentForm,
                'translate-x-[540px]': !showPaymentForm,
            }"
        >
            <button
                type="button"
                class="text-red-500 hover:text-red-400 transition-colors absolute top-4 right-4"
                @click="showPaymentForm = false"
            >
                <Icon icon="close" class="w-6 h-6" />
            </button>
            <div id="checkout" class="bg-white overflow-hidden py-6 px-4"></div>
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import { ref, onMounted } from 'vue';

let stripe = null;
const showPaymentForm = ref(false);

const initializeStripe = async () => {
    stripe = Stripe(import.meta.env.VITE_STRIPE_KEY);
    const response = await fetch('/checkout/subscription/embed', {
        method: 'GET',
    });

    const { clientSecret } = await response.json();

    const checkout = await stripe.initEmbeddedCheckout({
        clientSecret,
    });

    checkout.mount('#checkout');
};

onMounted(() => {
    initializeStripe();
});
</script>
